import * as TYPES from './constants';
import {API, JWT_HEADER} from 'config/srm.config';

import {receiveDemographic} from './actions';

const initialState = {
  request: false,
  error: false,
  data: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.REQUEST_DEMOGRAPHIC:
      return {
        request: true,
        error: false,
      };
    case TYPES.RECEIVE_DEMOGRAPHIC:
      return {
        ...state,
        request: false,
        error: false,
        data: action.payload,
      };
    case TYPES.REQUEST_DEMOGRAPHIC_ERROR:
      return {
        request: false,
        error: true,
      };
    default:
      return state;
  }
};

export const demographic = token => ({
  type: TYPES.APIREQUEST,
  payload: {
    endpoint: `${API.outreach.demographic}`,
    method: 'GET',
    headers: JWT_HEADER(token),
    onsuccess: receiveDemographic,
  },
});
